import {h, Component} from 'preact';
import { Link, withRouter } from 'react-router-dom';
import Cookies from 'universal-cookie';
import UserAuth from '../../services/userAuth';
import Util from '../../services/util';
import NavigationService from '../../services/navigation';
import FeatureSettingsService from '../../services/featureSettingsService';
import HelpService from '../../services/helpService';
import BackgroundContainer from './background-container';
import Footer from './footer';
import SupportFormModal from '../help/support-form-modal';
import DeviceComplianceSettingsProvider from '../../services/deviceComplianceSettingsProvider';
import OnboardingRedirectionService from '../../services/onboardingRedirectionService';
import { SessionStorageKeys } from '../../services/sessionStorageKeys.const';
import { featureFlags } from '../../services/featureFlags.const';

export class AuthComponent extends Component {
    constructor() {
        super();
        this.userAuth = new UserAuth();
        this.cookies = new Cookies();
		this.onboardingRedirectionService = new OnboardingRedirectionService();
        this.state = {
            isMobile: Util.isMobile(),
            companyProviderName: '',
            loginPageHeaderUrl: '',
            backgroundImageUrl: '',
            verificationError: '',
            helpInfo: {},
            isRenderHelpForm: false,
            footerClassName: '',
            isFooterHidden: false
        }
    }

    componentDidMount() {
        if(location.pathname.indexOf(process.env.basename + '/session-status') !== 0) {
            if (this.cookies.get('authenticationMode') === 'simple') {
                const authContainer = document.getElementById('auth-container');
                authContainer.classList.add('hidden');
                NavigationService.goToWebappUrl("/");
            }
            let settings = sessionStorage.getItem(SessionStorageKeys.companySettings);
            if (settings) {
                settings = JSON.parse(settings);
                this.setState({ ...settings });
            } else {
                UserAuth.getCompanySettings()
                    .then(({data}) => {
                        const settings = {
                            companyProviderName: data.companyProviderName,
                            loginPageHeaderUrl: data.theme.loginPageHeaderUrl,
                            backgroundImageUrl: data.theme.loginPageBackgroundUrl
                        };
                        this.setState({ ...settings });
                        sessionStorage.setItem(SessionStorageKeys.companySettings, JSON.stringify(settings));
                    }, error => {
                        console.log(error.response.data);
                    });
            }

            let helpInfo = sessionStorage.getItem(SessionStorageKeys.helpInfo);
            if (helpInfo) {
                helpInfo = JSON.parse(helpInfo);
                this.setHelpSource(helpInfo);
            } else {
                HelpService.getHelpInfo()
                    .then(({data}) => {
                        const helpInfo = { ...data };
                        this.setHelpSource(helpInfo);
                        sessionStorage.setItem(SessionStorageKeys.helpInfo, JSON.stringify(helpInfo));
                    });
            }
        }else{
            const authContainer = document.getElementById('auth-container');
            authContainer.classList.add('hidden');
        }
    }

    componentWillUnmount() {
        /* istanbul ignore else */
        if (this.authPollingTimer) {
            clearInterval(this.authPollingTimer);
            this.authPollingTimer = null;
        }
    }

    requireNativeAppInstall = (data, errorCallBack) => {
        data = data ? data : undefined;
        if(cssua.ua.desktop){
            UserAuth.getCompanySettings()
                .then((response) => {
                    if(response.data.requireNativeAppInstall){
                        if(response.data.passwordIsActivationCode){
                            sessionStorage.setItem(SessionStorageKeys.passwordIsActivationCode, response.data.passwordIsActivationCode);
                        }else{
                            sessionStorage.removeItem(SessionStorageKeys.passwordIsActivationCode);
                        }
                        this.goToNativeAppInstallation(response.data);
                    }else{
                        if(response.data.passwordIsActivationCode){
                            data = {
                                passwordExpiresIn: response.data.passwordExpiresIn,
                                passwordIsActivationCode: response.data.passwordIsActivationCode
                            };
                        }
                        this.loginForSimpleAuth(data);
                    }
                }, () => {
                    if(errorCallBack){
                        errorCallBack();
                    }else{
                        this.setState({loginError: 'Server error. Please try later.'});
                    }
                })
        }else{
            this.loginForSimpleAuth(data);
        }
    };

    pollingTimer = (successCb, failCb) => {
        this.authPollingTimer = setInterval(() => {
            UserAuth.getSessionStatus()
                .then(response => {
                    const data = response.data;
                    const status = response.status;
                    /* istanbul ignore else */
                    if (status === 200) {
                        clearInterval(this.authPollingTimer);
                        this.authPollingTimer = null;
                        if (successCb) {
                            successCb();
                        }
                        this.requireNativeAppInstall();
                    } else if (status === 202) {
                        const mfaInfo = { mfa: data };
                        this.mfaRedirection(mfaInfo, successCb);
                    }
                }, error =>{
                    if (failCb) {
                        failCb();
                    }
                    const data = error.response.data;
                    const status = error.response.status;
                    if(status === 400){
                        this.setState({verificationError: data});
                    }
                    if (status === 401) {
                        this.props.history.push({
                            pathname: '/',
                            search: location.search,
                            state: { from: this.props.location.pathname }
                        })
                    }
                });
        }, 3000);
    };

    goToPage = path => {
        this.props.history.push({
            pathname: path,
            search: location.search
        });
    };

    setHelpSource = helpInfo => {
        this.setState({
            helpInfo,
            isRenderHelpForm: !helpInfo.requestSupportUrl || helpInfo.requestSupportUrl.includes('/help/support-form')
        });
    };

    renderHelpLink = (className, withCompanyProviderName) => {
        if (this.state.isRenderHelpForm) {
            if (this.state.isMobile) {
                return (
                    <Link to='/help/support-form' className={`get-help-link ${className || ''}`}>
                        Get help
                        <span className={`${withCompanyProviderName && this.state.companyProviderName ? '' : 'hidden'}`}>
                            &nbsp;from {this.state.companyProviderName}
                        </span>
                    </Link>
                );
            }
            return (
                <a onClick={this.openSupportModal} className={`get-help-link ${className || ''}`}>
                    Get help
                    <span className={`${withCompanyProviderName && this.state.companyProviderName ? '' : 'hidden'}`}>
                        &nbsp;from {this.state.companyProviderName}
                    </span>
                </a>
            );
        }
        return (
            <a href={this.state.helpInfo.requestSupportUrl} className={`get-help-link ${className || ''}`} target='_blank'>
                Get help
                <span className={`${withCompanyProviderName && this.state.companyProviderName ? '' : 'hidden'}`}>
                    &nbsp;from {this.state.companyProviderName}
                </span>
            </a>
        );
    };

    focusById = id => {
        setTimeout(() => {
            if (document.getElementById(id)) {
                document.getElementById(id).focus();
            }
        }, 500);
    };

    buildBackUrl = fromUrl => {
        if (fromUrl) {
            return fromUrl;
        }
        return '/';
    };

    performJwtAutoLogin = data => {
        let backParam = Util.getUrlParameter('back');
        if (backParam) {
            backParam = backParam.replace(/login$/, '');
        }
        const backUrl = this.buildBackUrl(backParam);
        let autologinUrl = data.urls[0] + '/auth/v2/autologin';
        autologinUrl += '?token=' + data.token;
        autologinUrl += '&backurl=' + encodeURIComponent(backUrl);
        window.location.href = autologinUrl;
    };

    loginRedirection(data, back) {
        var frictionlessOnboardingEnabled = FeatureSettingsService.isFeatureEnabled(featureFlags.FrictionlessOnboardingEnabled);
        if (!frictionlessOnboardingEnabled && this.isOnboardingV1Redirection()) {
            return;
        }

        if (back === '/') {
            NavigationService.goToRoot();
            return;
        }

        if (data.type === 'federated') {
            back = back + '&webtoken=' + data.token;
        }
        window.location.replace(back);
    };

    callback = data => {
        sessionStorage.removeItem(SessionStorageKeys.passwordIsActivationCode);
        const back = Util.buildBackUrl(Util.getUrlParameter('back'));
        FeatureSettingsService.init().then(() => {
            this.loginRedirection(data, back);
        });
    };

    autoLogin = (data, callback) => {
        this.userAuth.startAutoLogin(data.urls, data.token)
            .then(callback)
            .catch(callback);
    };

    goToNativeAppInstallation = data => {
        const userSettings = {
            companyLogoUrl: data.theme.companyLogoUrl
        };
        sessionStorage.setItem(SessionStorageKeys.userSettings, JSON.stringify(userSettings));
        const deviceComplianceSettings = DeviceComplianceSettingsProvider.getNativeAppInstallationSettings();
        this.redirectToDeviceComplianceCheck(deviceComplianceSettings);
    };

    loginForSimpleAuth = data => {
        FeatureSettingsService.init()
            .then(() => {
                // if (parseInt(data.passwordExpiresIn) <= 0 && FeatureSettingsService.isFeatureEnabled('ChangePasswordInAuthAppEnabled')) {
                //     this.cookies.remove('authenticationMode', {path: '/'});
                //     this.goToPage('/password-expired');
                //     return false;
                // }

                if(data && data.passwordIsActivationCode && FeatureSettingsService.isFeatureEnabled('ChangePasswordInAuthAppEnabled')) {
                    this.goToPage('/reset-temp-password');
                    return false;
                }

                this.cookies.set('authenticationMode', 'simple', {path: '/'});
                sessionStorage.removeItem(SessionStorageKeys.redirectionCompleted);
                if (data && typeof data.autoLoginEnabled !== 'undefined') {

                } else {
                    data = {autoLoginEnabled: this.cookies.get('autoLoginEnabled') === 'enabled'};
                }

                if (data.autoLoginEnabled) {
                    UserAuth.getAutoLoginDataV2('/auth/v2/autologin')
                        .then(response => {
                            /* istanbul ignore else */
                            if (response.status === 200) {
                                const autoLoginData = response.data;
                                if (autoLoginData.type === 'Redirect' && process.env.NODE_ENV === 'production') {
                                    // This is for browsers which can't do autologin by ajax calls, like safari
                                    this.performJwtAutoLogin(autoLoginData);
                                } else {
                                    this.autoLogin(autoLoginData, this.callback.bind(this, data));
                                }
                            }
                        });
                } else {
                    this.callback(data);
                }
            } );
    };

    symantecRedirect = (data, state) => {
        this.cookies.set('authenticationMode', state, { path: '/' });
        this.goToPage('/symantec');
    };

    mfaRedirection = (data, callback) => {
        const mfa = data.mfa[0];
        /* istanbul ignore else */
        if (data.mfa.length === 0) {
            this.invokeCallback(callback);
            this.loginForSimpleAuth();
        } else if (mfa.type === 'sms' || mfa.type === 'guestSms') {
            this.cookies.set('authenticationMode', 'twoFactor', { path: '/' });
            sessionStorage.setItem(SessionStorageKeys.mfaType, mfa.type);
            sessionStorage.setItem(SessionStorageKeys.mfaTimeout, mfa.timeout);
            this.goToPage('/phone-auth');
        } else if (mfa.type === 'symantecVip' && Util.caseInsensitiveStringCompare(mfa.action, 'register')) {
            this.symantecRedirect(data, 'symantecVIPregister');
        } else if (mfa.type === 'symantecVip' && Util.caseInsensitiveStringCompare(mfa.action, 'activate')) {
            this.symantecRedirect(data, 'symantecVIPactivate');
        } else if (mfa.type === 'symantecVip' && Util.caseInsensitiveStringCompare(mfa.action, 'code')) {
            this.symantecRedirect(data, 'symantecVIP');
        } else if (mfa.type === 'signinVerification' && this.props.history.location.pathname !== '/verification') {
            if (mfa.isMfaStepConfigured ) {
                this.cookies.set('authenticationMode', 'signinVerification', { path: '/' });
                this.goToPage('/verification');
            } else {
                this.goToPage('/mobile-setup');
            }
        } else if (mfa.type === 'deviceCompliance') {
            this.invokeCallback(callback);
            const deviceComplianceSettings = DeviceComplianceSettingsProvider.getMfaSettings();
            this.redirectToDeviceComplianceCheck(deviceComplianceSettings);
        } else if (mfa.type === 'deviceComplianceV2') {
            this.invokeCallback(callback);
            const deviceComplianceSettings = DeviceComplianceSettingsProvider.getMfaSettings();
            this.redirectToDeviceComplianceCheckV2(deviceComplianceSettings, mfa);
        }
    };

    invokeCallback = (callback) => {
        if (callback) {
            callback();
        }
    }

    processOnboardingV3Redirection = (defaultRedirection) => {
        this.onboardingRedirectionService.processOnboardingV3Redirection(defaultRedirection);
    };

    redirectToDeviceComplianceCheck = (deviceComplianceSettings) => {
        this.cookies.set('w-device-compliance-check-info', JSON.stringify(deviceComplianceSettings), { path: '/' });
        this.cookies.remove('authenticationMode', { path: '/' });
        const backUrl = Util.getUrlParameter('back');
        NavigationService.goToWebappUrl('/', 'device-check', { back: backUrl });
    }

    redirectToDeviceComplianceCheckV2 = (deviceComplianceSettings, mfa) => {
        this.cookies.set('w-device-compliance-check-info', JSON.stringify(deviceComplianceSettings), { path: '/' });
        this.cookies.remove('authenticationMode', { path: '/' });
        const backUrl = Util.getUrlParameter('back');
        NavigationService.goToWebappUrl('/v2', 'device-check', { back: backUrl, 'login-marker': mfa.loginMarker });
    }

    openSupportModal = () => {
        this.child.openModal();
    };

    hideFooter = () => {
        this.setState({ isFooterHidden: true });
    };

    setFooterClassName = (footerClassName) => {
        this.setState({ footerClassName });
    };

    isOnboardingV1Redirection() {
        const onboardingStatus = sessionStorage.getItem(SessionStorageKeys.onboardingStatus);
        //onboardingV1 logic -->
        if (onboardingStatus === 'Required' || onboardingStatus === 'InProgress' || onboardingStatus === 'None') {
            NavigationService.goToWebappUrl('/welcome');
            //<-- onboardingV1 logic
            return true;
        }

        return false;
    }

    render() {
        return <div {...this.state} {...this.props}/>;
    }
}

const authContainer = (MyComponent) => {
    class WrappedComponent extends AuthComponent {
        render() {
            return(
                <div id='auth-container'>
                    {this.state.isMobile ? null : <BackgroundContainer backgroundImageUrl={this.state.backgroundImageUrl ? process.env.baseHref+this.state.backgroundImageUrl : null}/>}
                    <MyComponent {...this.state}
                                 {...this.props}
                                 callback={this.callback}
                                 loginForSimpleAuth={this.loginForSimpleAuth}
                                 requireNativeAppInstall={this.requireNativeAppInstall}
                                 mfaRedirection={this.mfaRedirection}
                                 goToPage={this.goToPage}
                                 renderHelpLink={this.renderHelpLink}
                                 focusById={this.focusById}
                                 hideFooter={this.hideFooter}
                                 setFooterClassName={this.setFooterClassName}
                                 pollingTimer={this.pollingTimer}
                                 verificationError={this.state.verificationError}
                                 companyProviderName={this.state.companyProviderName}
                                 loginPageHeaderUrl={this.state.loginPageHeaderUrl ? process.env.baseHref+this.state.loginPageHeaderUrl : null}
                                 helpInfo={this.state.helpInfo}
                                 processOnboardingV3Redirection={this.processOnboardingV3Redirection}
                    />
                    {this.state.isMobile || this.state.isFooterHidden ? null : <Footer className={this.state.footerClassName}/>}
                    {this.state.isRenderHelpForm ? <SupportFormModal ref={instance => { this.child = instance; }} helpInfo={this.state.helpInfo} /> : null}
                </div>
            );
        }
    }

    return withRouter(WrappedComponent);
};

export default authContainer;



// WEBPACK FOOTER //
// ./src/scripts/views/tags/auth-container.js